import React, { useMemo } from 'react'

const CaptionInput: React.FC<{ value: string, onChange: (text: string) => void, hashtags: string[], mentions: string[] }> = ({ value, onChange, hashtags, mentions }) => {

    const unusedHashtags = useMemo(() => {

        return hashtags.filter((hashtag) => !value.includes(hashtag));

    }, [hashtags, value])

    const showAddHashtagsButton = useMemo(() => {
        return unusedHashtags.length > 0
    }, [unusedHashtags])

    const unusedMentions = useMemo(() => {

        return mentions.filter((hashtag) => !value.includes(hashtag));

    }, [mentions, value])

    const showAddMentionsButton = useMemo(() => {
        return unusedMentions.length > 0
    }, [unusedMentions])

    const addUnusedHashtags = () => {
        if(unusedHashtags.length > 0){
            let updated_value = value;
            for(let hashtag of unusedHashtags){
                updated_value = `${updated_value} ${hashtag}`;
            }
            onChange(updated_value.trim());
        }
    }

      const addUnusedMentions = () => {
        if(unusedMentions.length > 0){
            let updated_value = value;
            for(let mention of unusedMentions){
                updated_value = `${updated_value} ${mention}`;
            }
            onChange(updated_value.trim());
        }
    }


    return (
        <div>
            <textarea rows={4} className='form-control form-builder-textarea' value={value ?? ''} onChange={(e) => onChange(e.target.value)}> </textarea>
            <div className="d-flex justify-content-center align-items-center gap-3 mt-2">
                {
                    showAddMentionsButton ? (
                        <button onClick={addUnusedMentions} className='caption-btn'>Add Mentions</button>
                    ) : null
                }
                {
                    showAddHashtagsButton ? (
                        <button onClick={addUnusedHashtags} className='caption-btn'>Add Hashtags</button>
                    ) : null
                }
            </div>
        </div>
    )
}

export default CaptionInput